export const geoZoneFromService = (zone) => ({
    id: zone.id,
    name: zone.name,
    source: zone.source,
    ...("latitude" in zone && { latitude: zone.latitude }),
    ...("longitude" in zone && { longitude: zone.longitude }),
    ...("population" in zone && { population: zone.population }),
    zipCodes: zone.zip_codes?.zip_codes ?? null
});
export const geoTargetingFromService = (geo) => ({
    insightBlurb: geo.insight_blurb,
    ...("total_households" in geo && { totalHouseholds: geo.total_households }),
    ...("total_population" in geo && { totalPopulation: geo.total_population }),
    zones: geo.zones ? geo.zones.map(geoZoneFromService) : null
});
//# sourceMappingURL=geo.js.map